// extracted by mini-css-extract-plugin
export default {"clickableCell":"EditableCell_clickableCell__GscXa","input":"EditableCell_input__X81SB"};